export interface Order {
    id?: number; 
    customerId: string; 
    traderId: string;
    branchId: string;
    traderSiteId : string;
    creationDate: Date;
    notes: string;
    lines: OrderLine[];
    sent: boolean;
  }
  
  export interface OrderLine {
    id?: string; // GUID
    orderId: number; // long
    itemId: string; // GUID
    quantity: number; // decimal
    price: number; // decimal
  }


  export function createOrder(
    customerId: string,
    traderId: string,
    branchId: string,
    traderSiteId :string,
    notes: string = "",
    initialLines: OrderLine[] = []
  ): Order {
    return {
      id: 0, 
      customerId,
      traderId,
      traderSiteId,
      branchId,
      creationDate: new Date(),
      notes,
      lines: initialLines,
      sent: false
    };
  }
  
  export function createOrderLine(
    orderId: number,
    itemId: string,
    quantity: number,
    price: number
  ): OrderLine {
    return {
      id: null, 
      orderId,
      itemId,
      quantity,
      price
    };
  }